import { render, staticRenderFns } from "./vipDailyBillDetail.vue?vue&type=template&id=85df9d24&scoped=true&"
import script from "./vipDailyBillDetail.vue?vue&type=script&lang=js&"
export * from "./vipDailyBillDetail.vue?vue&type=script&lang=js&"
import style0 from "./vipDailyBillDetail.vue?vue&type=style&index=0&id=85df9d24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85df9d24",
  null
  
)

export default component.exports